import type { TTSchoolRole } from "./api";

// Pin the direct ownership relationships. Checkpoint/junction tables must never
// change the meaning of school counts when PostgREST discovers new relationships.
export const TIMETABLE_SCHOOL_SELECT =
  "*, schedule_manager_teacher!schedule_manager_tea_school_id_d20b705d_fk_schedule_(count), schedule_manager_classroom!schedule_manager_cla_school_id_8a53355e_fk_schedule_(count), schedule_manager_timetable!schedule_manager_tim_school_id_5e6fc89f_fk_schedule_(count)";

export type SchoolListMembership = {
  school_id: number;
  role: string;
  user_id?: number | null;
};

export type SchoolListRow = {
  id: number;
  admin_id?: number | null;
};

/**
 * Superuser RLS returns every school and every membership.
 * "내 학교 목록" must keep only rows the current user actually owns,
 * was invited to, or is linked to as a teacher.
 */
export function attachMySchoolRoles<T extends SchoolListRow>(
  schools: T[],
  myDjangoId: number,
  myMemberships: SchoolListMembership[],
  myLinkedTeacherSchoolIds: number[]
): Array<T & { my_role: TTSchoolRole }> {
  const membershipMap = new Map<number, "admin" | "viewer">();
  for (const membership of myMemberships) {
    if (membership.user_id != null && Number(membership.user_id) !== Number(myDjangoId)) continue;
    if (membership.role === "admin" || membership.role === "viewer") {
      membershipMap.set(Number(membership.school_id), membership.role);
    }
  }
  const linkedTeacherSchoolIds = new Set(myLinkedTeacherSchoolIds.map(Number));

  const result: Array<T & { my_role: TTSchoolRole }> = [];
  for (const school of schools) {
    let myRole: TTSchoolRole | null = null;
    if (Number(school.admin_id) === Number(myDjangoId)) {
      myRole = "owner";
    } else if (membershipMap.has(Number(school.id))) {
      myRole = membershipMap.get(Number(school.id)) ?? null;
    } else if (linkedTeacherSchoolIds.has(Number(school.id))) {
      myRole = "teacher";
    }
    if (!myRole) continue;
    result.push({ ...school, my_role: myRole });
  }
  return result;
}
